export default __webpack_public_path__ + "static/media/location--10.c0000c7c.jpg";